import ArrowLeftRightIcon from '@liquidweb-dev/undercurrent/icons/lucide/ArrowLeftRight';
import CircleStarIcon from '@liquidweb-dev/undercurrent/icons/lucide/CircleStar';
import CoinsIcon from '@liquidweb-dev/undercurrent/icons/lucide/Coins';
import CreditCardIcon from '@liquidweb-dev/undercurrent/icons/lucide/CreditCard';
import LandmarkIcon from '@liquidweb-dev/undercurrent/icons/lucide/Landmark';
import ListIcon from '@liquidweb-dev/undercurrent/icons/lucide/List';
import MastercardIcon from '@liquidweb-dev/undercurrent/icons/platform/Mastercard';
import PayPalIcon from '@liquidweb-dev/undercurrent/icons/platform/PayPal';
import VisaIcon from '@liquidweb-dev/undercurrent/icons/platform/Visa';
import AmericanExpressLogo from '@liquidweb-dev/undercurrent/logos/AmericanExpress';
import DiscoverLogo from '@liquidweb-dev/undercurrent/logos/Discover';
import { FixedColorSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';

import normalizePaymentMethodType from 'modules/invoices/normalizePaymentMethodType';

export interface PaymentMethodIconProps extends FixedColorSvgProps {
	paymentMethod?: string | null;
	issuer?: string | null;
}

const PaymentMethodIcon = ({
	paymentMethod,
	issuer,
	...rest
}: PaymentMethodIconProps) => {
	const normalizedPaymentMethod = normalizePaymentMethodType(paymentMethod);

	if (
		normalizedPaymentMethod === 'check' ||
		normalizedPaymentMethod === 'ach'
	) {
		return <LandmarkIcon {...rest} />;
	}

	if (normalizedPaymentMethod === 'paypal') {
		return <PayPalIcon {...rest} />;
	}

	if (normalizedPaymentMethod === 'accountcredit') {
		return <CoinsIcon {...rest} />;
	}

	if (normalizedPaymentMethod === 'balancetransfer') {
		return <ArrowLeftRightIcon {...rest} />;
	}

	if (normalizedPaymentMethod === 'legacy') {
		return <CircleStarIcon {...rest} />;
	}

	if (normalizedPaymentMethod === 'multiple') {
		return <ListIcon {...rest} />;
	}

	if (normalizedPaymentMethod === 'creditcard') {
		switch (issuer?.toLowerCase()) {
			case 'visa':
				return <VisaIcon {...rest} />;

			case 'mastercard':
				return <MastercardIcon {...rest} />;

			case 'discover':
				return <DiscoverLogo {...rest} />;

			case 'american_express':
				return <AmericanExpressLogo {...rest} />;

			default:
				return <CreditCardIcon {...rest} />;
		}
	}

	return null;
};

export default PaymentMethodIcon;
